import { Controller } from "@hotwired/stimulus"
import TimeAgo from 'javascript-time-ago'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

// English.
import ru from 'javascript-time-ago/locale/ru'

TimeAgo.addDefaultLocale(ru)

export default class extends Controller {
  static values = {
    date: String
  }
  connect() {
    const timeAgo = new TimeAgo('ru-RU')
    let date = dayjs.utc().toDate()
    if (this.hasDateValue) {
      date = dayjs.utc(this.dateValue, "DD-MM-YYYY H:mm").toDate()
    }
    console.log(dayjs.utc(this.dateValue).toDate())
    this.element.textContent = timeAgo.format(date)
  }
}
